import React from 'react';
import SkeletonLoader from './SkeletonLoader';
import StaticPageLayout from '../../layouts/StaticPageLayout';

/**
 * Komponent ładowania (skeleton) dla strony wpisu na blogu.
 * Zintegrowany z nowym StaticPageLayout i stylem Glassmorphism.
 */
const BlogPostSkeleton: React.FC = () => {
    return (
        <StaticPageLayout centered={false}>
            <div className="max-w-4xl mx-auto pb-20 px-4 sm:px-0 w-full animate-pulse">

                {/* Placeholder przycisku powrotu */}
                <div className="mb-8">
                    <SkeletonLoader className="h-10 w-32 rounded-xl bg-white/5 border border-white/5" />
                </div>

                {/* NAGŁÓWEK - Data i Tytuły */}
                <div className="flex flex-col items-center mb-12">
                    <SkeletonLoader className="h-6 w-32 rounded-full mb-6 bg-white/5" />
                    <SkeletonLoader className="h-12 w-full max-w-2xl mb-4 rounded-xl bg-white/10" />
                    <SkeletonLoader className="h-12 w-3/4 max-w-lg mb-6 rounded-xl bg-white/10" />
                    <SkeletonLoader className="h-5 w-2/3 max-w-md rounded-lg bg-white/5" />
                </div>

                {/* OBRAZ GŁÓWNY (HERO IMAGE) */}
                <SkeletonLoader className="w-full aspect-video rounded-3xl mb-12 bg-white/5 shadow-2xl border border-white/5" />

                {/* KONTENER TREŚCI - Stylizowany na szklaną kartę */}
                <div className="bg-gray-800/40 backdrop-blur-md border border-white/10 p-8 md:p-12 rounded-3xl shadow-xl">
                    <div className="space-y-6">
                        <SkeletonLoader className="h-4 w-full rounded bg-white/5" />
                        <SkeletonLoader className="h-4 w-full rounded bg-white/5" />
                        <SkeletonLoader className="h-4 w-11/12 rounded bg-white/5" />

                        {/* Placeholder dla ewentualnego obrazu wewnątrz treści lub cytatu */}
                        <div className="py-8">
                            <SkeletonLoader className="h-48 w-full rounded-2xl bg-white/10" />
                        </div>

                        <SkeletonLoader className="h-4 w-full rounded bg-white/5" />
                        <SkeletonLoader className="h-4 w-5/6 rounded bg-white/5" />
                        <SkeletonLoader className="h-4 w-full rounded bg-white/5" />
                    </div>
                </div>

                {/* POWIĄZANE POSTY (DOLNA SEKCJA) */}
                <div className="mt-16 pt-8 border-t border-white/10">
                    <SkeletonLoader className="h-8 w-48 mb-8 rounded-lg bg-white/10" />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <SkeletonLoader className="h-40 rounded-2xl bg-white/5 border border-white/5" />
                        <SkeletonLoader className="h-40 rounded-2xl bg-white/5 border border-white/5" />
                    </div>
                </div>
            </div>
        </StaticPageLayout>
    );
};

export default BlogPostSkeleton;